module.exports = __webpack_public_path__ + "static/media/cockroach(1).52b3a818.PNG";